import type { LinkPaymentMethod } from '../../openApi';

export const OrderPaymentMethods: { [K in LinkPaymentMethod]: K } = {
    CARD_ONLINE: 'CARD_ONLINE',
    CARD_ON_DELIVERY: 'CARD_ON_DELIVERY',
    CASH_ON_DELIVERY: 'CASH_ON_DELIVERY',
};
